var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
export class ModelMediaCategory {
    childCount;
    communityId;
    id;
    level;
    name;
    parentId;
    position;
    tagsCount;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelMediaCategory.prototype, "childCount", void 0);
__decorate([
    Expose({ name: 'community_id' }),
    __metadata("design:type", String)
], ModelMediaCategory.prototype, "communityId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelMediaCategory.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelMediaCategory.prototype, "level", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelMediaCategory.prototype, "name", void 0);
__decorate([
    Expose({ name: 'parent_id' }),
    __metadata("design:type", Object)
], ModelMediaCategory.prototype, "parentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelMediaCategory.prototype, "position", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelMediaCategory.prototype, "tagsCount", void 0);
